import {
  fetchDelete, fetchGet, fetchPost, fetchPut,
} from '../../providers/Fetch';
import { getQueryStringFilter } from '../../modules/getUrls';

import {
  ADD_USER,
  DELETE_USER,
  UPDATE_USER,
  USERS_ERROR,
  USERS_REQUEST,
  USERS_SUCCESS,
  USERS_ADD_NOTIFICATION,
  USERS_CLEAN_NOTIFICATION,
} from './types';

export const addUser = user => ({
  type: ADD_USER,
  user,
});

export const deleteUser = user => ({
  type: DELETE_USER,
  user,
});

export const updateUser = user => ({
  type: UPDATE_USER,
  user,
});

export const usersError = error => ({
  type: USERS_ERROR,
  error,
});

export const usersRequest = {
  type: USERS_REQUEST,
};

export const usersSuccess = data => ({
  type: USERS_SUCCESS,
  data,
});

export const addNotification = notification => ({
  type: USERS_ADD_NOTIFICATION,
  notification,
});

export const cleanNotification = notification => ({
  type: USERS_CLEAN_NOTIFICATION,
  notification,
});

export const usersFetch = ({
  filtered = [],
  page = 0,
  pageSize = 20,
  sorted = [],
}) => async (dispatch) => {
  dispatch(usersRequest);
  try {
    const queryString = getQueryStringFilter({
      filtered,
      page,
      pageSize,
      sorted,
    });

    const url = `/user?${queryString}`;
    const result = await fetchGet(url);
    dispatch(usersSuccess(result));
  } catch (e) {
    dispatch(usersError(e.message));
  }
};

export const addUserFetch = user => async (dispatch) => {
  dispatch(usersRequest);
  try {
    const result = await fetchPost('/user', user);
    dispatch(addUser(result));
    dispatch(addNotification({
      error  : false,
      message: 'The user has been created successfully',
    }));
  } catch (e) {
    dispatch(usersError(e.message));
    dispatch(addNotification({
      error  : true,
      message: 'Error creating the user',
    }));
  }
};

export const deleteUserFetch = user => async (dispatch) => {
  dispatch(usersRequest);
  try {
    const result = await fetchDelete('/user', user);
    dispatch(deleteUser(result));
    dispatch(addNotification({
      error  : false,
      message: 'The user has been deleted successfully',
    }));
  } catch (e) {
    dispatch(usersError(e.message));
    dispatch(addNotification({
      error  : true,
      message: 'Error deleting the user',
    }));
  }
};

export const updateUserFetch = user => async (dispatch) => {
  dispatch(usersRequest);
  try {
    const result = await fetchPut('/user', user);
    dispatch(updateUser(result));
    dispatch(addNotification({
      error  : false,
      message: 'The user has been updated successfully',
    }));
  } catch (e) {
    dispatch(usersError(e.message));
    dispatch(addNotification({
      error  : true,
      message: 'Error updating the user',
    }));
  }
};
